import styled from 'styled-components';
import { Row } from 'react-styled-flexboxgrid';

export const $Row = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.disabled};
  padding: 1rem 0;
`;
